import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import WebUI1440Articles from 'components/Web_User_Interface/1440p_Series/IntroWebUI1440';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Features Menü",
  "path": "/Web_User_Interface/1440p_Serie/Features/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR Web User Interface - Features Menü",
  "image": "./WebUI_1440p_SearchThumb_Features.webp",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface' dateChanged='2017-12-11' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die HTML5-Web-Benutzeroberfläche ermöglicht eine einfache Konfiguration und Kamerasteuerung über Ihren Standard-Webbrowser wie Chrome, Safari, Firefox, Internet Explorer.' image='/images/Search/WebUI_1440p_SearchThumb_Features.webp' twitter='/images/Search/WebUI_1440p_SearchThumb_Features.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/' locationFR='/fr/Web_User_Interface/1440p_Series/' crumbLabel="UltraHD WebUI" mdxType="BreadCrumbs" />
    <WebUI1440Articles mdxType="WebUI1440Articles" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      